import { type Schedule } from "@repo/api";

export const sortSchedule = (a: Schedule, b: Schedule) => {
  return a.shiftStartTime - b.shiftStartTime;
};
